import React, { useEffect, useState } from "react";
import type { LegalSection } from "../../data/legal";
interface LegalPageProps {
  title: string;
  updated: string;
  sections: LegalSection[];
}
export function LegalPage({
  title,
  updated,
  sections
}: LegalPageProps) {
  const [active, setActive] = useState(sections[0]?.id);
  useEffect(() => {
    const obs = new IntersectionObserver(entries => {
      const v = entries.find(e => e.isIntersecting);
      if (v) setActive(v.target.id);
    }, {
      rootMargin: "-20% 0px -70% 0px"
    });
    sections.forEach(s => {
      const el = document.getElementById(s.id);
      if (el) obs.observe(el);
    });
    return () => obs.disconnect();
  }, [sections]);
  return <div className="mx-auto max-w-6xl px-5 py-16 md:px-8 md:py-24" data-id="element-839" data-mp="2xymqbldn8oua">
      <header data-id="element-840" data-mp="32zj0uhsi398o">
        <h1 className="text-[clamp(38px,6vw,64px)] font-bold leading-[1.05] tracking-[-0.02em]" data-id="element-841" data-mp="3302azcbwstc5">{title}</h1>
        <p className="mt-3 text-[15px] text-ink-2" data-id="element-842" data-mp="37yvo33naaibs">Last updated {updated}</p>
      </header>
      <div className="mt-12 grid gap-10 lg:grid-cols-[220px_1fr]" data-id="element-843" data-mp="3gcn5o7of2sp">
        <nav aria-label="On this page" className="hidden lg:block" data-id="element-844" data-mp="3ululcuguly76">
          <ol className="sticky top-28 space-y-1 border-l-3 border-line" data-id="element-845" data-mp="3unp72azy1ucb">
            {sections.map(s => <li key={s.id} data-id="element-846" data-mp="3qlu5d5e3pey0">
                <a href={`#${s.id}`} className={`focus-ring -ml-[3px] block border-l-3 py-1.5 pl-4 text-sm font-semibold transition-colors duration-150 ${active === s.id ? "border-brand text-ink" : "border-transparent text-ink-2 hover:text-ink"}`} data-id="element-847" data-mp="3llg0txbpkn4q">
                  {s.title}
                </a>
              </li>)}
          </ol>
        </nav>
        <article className="max-w-[68ch] rounded-panel border-3 border-line bg-surface p-6 md:p-10" data-id="element-848" data-mp="8e4iks7j571n">
          {sections.map(s => <section key={s.id} id={s.id} className="scroll-mt-28 border-b-2 border-line/10 py-6 first:pt-0 last:border-b-0 last:pb-0" data-id="element-849" data-mp="113boic9bcywx">
              <h2 className="text-xl font-bold tracking-[-0.01em]" data-id="element-850" data-mp="1k0lkf5a2djfn">{s.title}</h2>
              {s.body.map((p, i) => <p key={i} className="mt-3 text-[17px] leading-relaxed text-ink-2" data-id="element-851" data-mp="1oxlq3f304k68" data-mpi={i}>
                  {p}
                </p>)}
            </section>)}
        </article>
      </div>
    </div>;
}